import { Skeleton } from '@chakra-ui/react';

import { DataTable } from './data-table';
import { dataTableRowHeight } from './data-table.kds';

export interface DataTableSkeletonProps {
  /** Number of skeleton rows to render. Defaults to 10. */
  rows?: number;
  /** Column identifiers (e.g. header labels) — one skeleton cell per column. */
  columns?: string[];
  /** Append extra skeleton cells for columns not in `columns` (e.g. action/menu columns). Pass `true` for 1 or a number for more. */
  showExtraColumn?: boolean | number;
  /** Height of each skeleton placeholder. Defaults to 20px. */
  skeletonHeight?: string;
}

export const DataTableSkeleton = ({
  rows = 10,
  columns = [],
  showExtraColumn = false,
  skeletonHeight = '20px',
}: Readonly<DataTableSkeletonProps>) => {
  const extraCount = showExtraColumn === true ? 1 : (showExtraColumn || 0);

  return (
    <>
      {Array.from({ length: rows }, (_, index) => (
        <DataTable.Row height={dataTableRowHeight} key={index}>
          {columns.map(col => (
            <DataTable.Cell key={col}>
              <Skeleton width="full" height={skeletonHeight} />
            </DataTable.Cell>
          ))}
          {Array.from({ length: extraCount }, (_, i) => (
            <DataTable.Cell key={`extra-${i}`}>
              <Skeleton minWidth="105px" height={skeletonHeight} />
            </DataTable.Cell>
          ))}
        </DataTable.Row>
      ))}
    </>
  );
};
